import { credentialsFormatters } from './gridFormatters';

export const credentialsHeaders = [
  { header: 'aggregatorID', label: 'Node' },
  { header: 'status', label: 'Status' },
  {
    header: 'action',
    label: 'Action',
    formatter: credentialsFormatters.formatAction,
    maxWidth: '100px',
  },
];
